import { Outlet } from 'react-router-dom';
import Box from '@/components/ui/Box/Box';
import Grid from '@/components/ui/Grid/Grid';
import AppErrorSnackbar from '@/components/business/AppErrorSnackbar/AppErrorSnackbar';
import fullLogo from '@/assets/images/logo_full.svg';
import { styles } from './styles';

export const LoginLayout = () => (
    <Box sx={styles.background}>
        <Grid container item alignItems="center" justifyContent="space-between" sx={styles.appBar}>
            <img src={fullLogo} style={styles.fullLogoImg} alt="Repair Exchange" />
        </Grid>
        <Grid
            container
            item
            alignItems="center"
            justifyContent="center"
            sx={styles.menu}
            xs={10}
            sm={8}
            md={6}
            lg={5}
        >
            <Outlet />
        </Grid>
        <Box sx={{ width: '100%', height: '100px', position: 'relative' }}>
            <AppErrorSnackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} />
        </Box>
    </Box>
);
